import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import { useEffect } from 'react';

export default function BrandsPage() {
  useEffect(() => {
    // Add Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "Our Brands - Exalt Ventures Ltd.",
      "description": "Discover our curated portfolio of distinguished British fashion brands, each bringing timeless elegance and exceptional quality to North Africa and Malta.",
      "url": `${import.meta.env.VITE_SITE_URL || "https://exaltventures.com"}/brands`,
      "about": [
        {
          "@type": "Brand",
          "name": "Monsoon Children",
          "description": "British fashion brand renowned for its distinctive style, quality craftsmanship, and timeless appeal."
        },
        {
          "@type": "Brand",
          "name": "Accessorize",
          "description": "British fashion brand providing sophisticated accessories for the modern woman with exceptional quality and design."
        },
        {
          "@type": "Brand",
          "name": "Dune London",
          "description": "British premium footwear and accessories brand celebrated for its contemporary designs, exceptional quality, and accessible luxury."
        }
      ]
    });
    document.head.appendChild(script);
    
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navigation />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-5xl font-serif text-[#003264] mb-6 leading-tight">Our Brands</h1>
            <p className="text-base text-[#003264] leading-relaxed">
              Discover our curated portfolio of distinguished British fashion brands, each bringing timeless elegance and exceptional quality to North Africa and Malta.
            </p>
          </div>
        </div>
      </section>

      {/* Monsoon Children */}
      <section className="py-16 bg-[#FAFAFA]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="bg-white overflow-hidden">
              <div className="grid md:grid-cols-2 gap-0">
                <div className="w-full h-80 md:h-auto">
                  <img 
                    src="https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/46133e298ec765a82bd64d571f457fbd.png" 
                    alt="Monsoon Children Store"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-12">
                  <h2 className="text-3xl font-serif text-[#003264] mb-5 font-bold">Monsoon Children</h2>
                  <p className="text-sm text-[#003264] mb-6 leading-relaxed">
                    British fashion brand renowned for its distinctive style, quality craftsmanship, and timeless appeal. Monsoon Children offers enchanting collections for young ones with sophisticated designs and exceptional quality.
                  </p>
                  
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-base font-serif text-[#003264] mb-3">Exalt Exclusive Franchise</h3>
                      <div className="space-y-2 text-sm text-[#003264]">
                        <p className="flex items-center">
                          <span className="w-1.5 h-1.5 bg-[#64C8FA] rounded-full mr-2"></span>
                          Libya since 2008
                        </p>
                        <p className="flex items-center">
                          <span className="w-1.5 h-1.5 bg-[#64C8FA] rounded-full mr-2"></span>
                          Algeria since 2017
                        </p>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-base font-serif text-[#003264] mb-3">Store Network:</h3>
                      <div className="space-y-3 text-sm text-[#003264]">
                        <div>
                          <p className="font-semibold mb-1">Libya: 3 x Monsoon Children Stores</p>
                          <p className="pl-4">Jraba Mall Tripoli; Gargaresh Tripoli; Mashtel Tripoli</p>
                        </div>
                        <div>
                          <p className="font-semibold mb-1">Algeria: 3 x Monsoon Children Stores</p>
                          <p className="pl-4">Bab Ezzouar Algiers; Garden City Mall Algiers; Es Senia Mall Oran</p>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-base font-serif text-[#003264] mb-3">Product Range</h3>
                      <p className="text-sm text-[#003264] leading-relaxed">
                        Children's clothing and accessories that blend contemporary style with traditional craftsmanship, offering enchanting collections for young ones.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Accessorize */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="bg-[#FAFAFA] overflow-hidden">
              <div className="grid md:grid-cols-2 gap-0">
                <div className="p-12 order-2 md:order-1">
                  <h2 className="text-3xl font-serif text-[#003264] mb-5 font-bold">Accessorize</h2>
                  <p className="text-sm text-[#003264] mb-6 leading-relaxed">
                    British fashion brand renowned for its distinctive style, quality craftsmanship, and timeless appeal. Accessorize provides sophisticated accessories for the modern woman with exceptional quality and design.
                  </p>
                  
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-base font-serif text-[#003264] mb-3">Exalt Exclusive Franchise</h3>
                      <div className="space-y-2 text-sm text-[#003264]">
                        <p className="flex items-center">
                          <span className="w-1.5 h-1.5 bg-[#64C8FA] rounded-full mr-2"></span>
                          Libya since 2008
                        </p>
                        <p className="flex items-center">
                          <span className="w-1.5 h-1.5 bg-[#64C8FA] rounded-full mr-2"></span>
                          Algeria since 2017
                        </p>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-base font-serif text-[#003264] mb-3">Store Network:</h3>
                      <div className="space-y-3 text-sm text-[#003264]">
                        <div>
                          <p className="font-semibold mb-1">Libya: 3 x Accessorize Stores</p>
                          <p className="pl-4">Jraba Mall Tripoli; Gargaresh Tripoli; Mashtel Tripoli</p>
                        </div>
                        <div>
                          <p className="font-semibold mb-1">Algeria: 3 x Accessorize Stores</p>
                          <p className="pl-4">Bab Ezzouar Algiers; Garden City Mall Algiers; Es Senia Mall Oran</p>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-base font-serif text-[#003264] mb-3">Product Range</h3>
                      <p className="text-sm text-[#003264] leading-relaxed">
                        Women's accessories, fine jewellery, premium handbags, scarves, and lifestyle products that blend contemporary style with traditional craftsmanship.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-full h-80 md:h-auto order-1 md:order-2">
                  <img 
                    src="https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/1f9752e6208472cc0fa8d741d08b408e.jpeg" 
                    alt="Accessorize Store"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Dune London */}
      <section className="py-16 bg-[#FAFAFA]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="bg-white overflow-hidden">
              <div className="grid md:grid-cols-2 gap-0">
                <div className="w-full h-80 md:h-auto">
                  <img 
                    src="https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/20cf2fe850c7e08c95021503b140e9e2.jpeg" 
                    alt="Dune London Store"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-12">
                  <h2 className="text-3xl font-serif text-[#003264] mb-5 font-bold">Dune London</h2>
                  <p className="text-sm text-[#003264] mb-6 leading-relaxed">
                    Established in 1992, Dune London is a British premium footwear and accessories brand celebrated for its contemporary designs, exceptional quality, and accessible luxury. The brand represents the perfect fusion of style and substance.
                  </p>
                  
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-base font-serif text-[#003264] mb-3">Exalt Franchise Territories</h3>
                      <div className="space-y-2 text-sm text-[#003264]">
                        <p className="flex items-center">
                          <span className="w-1.5 h-1.5 bg-[#64C8FA] rounded-full mr-2"></span>
                          Libya since 2010
                        </p>
                        <p className="flex items-center">
                          <span className="w-1.5 h-1.5 bg-[#64C8FA] rounded-full mr-2"></span>
                          Algeria since 2017
                        </p>
                        <p className="flex items-center">
                          <span className="w-1.5 h-1.5 bg-[#64C8FA] rounded-full mr-2"></span>
                          Malta since 2019
                        </p>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-base font-serif text-[#003264] mb-3">Store Network:</h3>
                      <div className="space-y-3 text-sm text-[#003264]">
                        <div>
                          <p className="font-semibold mb-1">Libya: 3 x Dune London Stores</p>
                          <p className="pl-4">Jraba Mall Tripoli; Hai Al Andalus Tripoli; Mashtel Tripoli</p>
                        </div>
                        <div>
                          <p className="font-semibold mb-1">Algeria: 3 x Accessorize Stores</p>
                          <p className="pl-4">Bab Ezzouar Algiers; Garden City Mall Algiers; Es Senia Mall Oran</p>
                        </div>
                        <div>
                          <p className="font-semibold mb-1">Malta: 4 x Dune London Stores</p>
                          <p className="pl-4">Tigne Point Mall Sliema; Mosta; Fgura; Centre Parc Mall Qormi</p>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-base font-serif text-[#003264] mb-3">Product Collections</h3>
                      <p className="text-sm text-[#003264] leading-relaxed">
                        Men's and women's footwear, luxury handbags, premium accessories, and lifestyle products. Each piece reflects meticulous attention to detail and contemporary British design sensibility.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Brand Heritage */}
      <section className="py-16 bg-[#FAFAFA]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-3xl font-serif text-[#003264] mb-10">British Fashion Heritage</h2>
            <p className="text-sm text-[#003264] leading-relaxed">
              Our partnership with these distinguished British brands reflects our commitment to bringing authentic, high-quality fashion to our markets. Each brand in our portfolio has been carefully selected for its heritage, design excellence, and alignment with our values of sophistication and quality.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
